export const MODULE = "new/user-session";
